import { mapState, mapActions, mapGetters } from "vuex";
import staticColors from "@/model/colors";
import { enumHelper } from "@/utilities";
import _ from "lodash";
const AppInit = {
  install(Vue) {
    Vue.mixin({
      computed: {
        ...mapGetters(["getCategories"]),
        ...mapState({
          selectedLocation: (state) => state.selectedLocation,
          myTheme: (state) => state.theme,
          currentCurrency:(state) => state.currentCurrency
        }),
        locationMenuItems(){
          const itemFound = this.getCategories ? this.getCategories.find(item => item.location_id == this.selectedLocation.id) : [];
          return itemFound ? itemFound.categories : []
        }
      },
      data() {
        return {
          staticColor: staticColors,
        };
      },
      methods: {
        ...mapActions(["fetchLocationsByPostCode", "fetchTheme"]),
        isLocationEmpty() {
          return _.isEmpty(this.selectedLocation);
        },
        refreshLocationData() {
          return new Promise((resolve) => {
            //**** check if the cart is not expired */
            if (this.cart.orderType == enumHelper.orderType.Delivery) {
              if (this.cart.postCode) {
                //**** get location by postcode */
                this.fetchLocationsByPostCode(this.cart.postCode)
                  .then((response) => {
                    this.$store.dispatch(
                      "storeSelectedLocation",
                      response.data.data.find(
                        (x) => x.id == this.selectedLocation.id
                      )
                    );
                    resolve();
                  })
                  .catch((e) => {
                    this.captureException(e);
                    this.fetchTheme().then(() => {
                      resolve();
                    }).catch((e)=>{this.captureException(e);});
                  });
              }
            } else {
              this.fetchTheme().then(() => {
                resolve();
              }).catch((e)=>{this.captureException(e);});
            }
          });
        },
      },

    });
  }
};
export default AppInit;
